import React, { useState, useEffect, SetStateAction, Dispatch } from "react";

function useLoginSelector(
  handleSignIn: (
    event: React.KeyboardEvent | React.MouseEvent<HTMLButtonElement>
  ) => void,
  setUser: Dispatch<SetStateAction<string>>
) {
  const [showPassword, setShowPassword] = useState(false);

  const sessionExpired =
    JSON.parse(localStorage.getItem("session") || JSON.stringify("active")) ===
    "expired";

  const handleEnterPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSignIn(e);
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleMouseDownPassword = (event: React.MouseEvent) =>
    event.preventDefault();

  useEffect(() => {
    sessionStorage.clear();
    setUser("");
  }, []);

  return {
    sessionExpired,
    handleEnterPress,
    handleClickShowPassword,
    handleMouseDownPassword,
    showPassword
  };
}

export default useLoginSelector;
